import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// UI
import P from "../paragraph";

function LinkOrText(props) {
  if (props.id && typeof props.id === "string" && props.id.length) {
    return (
      <Link
        to={`${props.toBeforeId}${props.needInsertIdInMiddle ? props.id : ""}${
          props.toAfterId
        }`}
        className={props.className}
      >
        {props.children}
      </Link>
    );
  } else {
    if (props.textAsP) {
      return React.createElement(
        P,
        {
          className: props.className,
          ...props.propsTextP
        },
        props.children
      );
    } else {
      return <span className={props.className}>{props.children}</span>;
    }
  }
}

LinkOrText.defaultProps = {
  toBeforeId: "",
  needInsertIdInMiddle: true,
  toAfterId: "",
  id: null,
  textAsP: false,
  propsTextP: {},
  className: "",
  children: null
};

LinkOrText.propTypes = {
  toBeforeId: PropTypes.string,
  needInsertIdInMiddle: PropTypes.bool,
  toAfterId: PropTypes.string,
  id: PropTypes.string,
  textAsP: PropTypes.bool,
  propsTextP: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.node
};

export default LinkOrText;
